import createHttpClient from './HttpClient'

const httpClient = createHttpClient()

export async function fetchCharacterWounds(slug) {
  const response = await httpClient.get(`/api/v1/characters/${slug}/wounds`)
  return response.data?.data || null
}

export async function saveWoundReport(slug, zones) {
  const response = await httpClient.put(`/api/v1/characters/${slug}/wounds`, { zones })
  return response.data?.data || null
}

export async function healCharacterWound(slug) {
  const response = await httpClient.post(`/api/v1/characters/${slug}/wounds/heal`, {})
  return response.data?.data || null
}

export async function voidCharacterWound(slug) {
  const response = await httpClient.post(`/api/v1/characters/${slug}/wounds/void`, {})
  return response.data?.data || null
}
